// SPDX-License-Identifier: MIT
import { DESIGN_H, DESIGN_W } from './scene.ts';
export type Vec3 = [
    number,
    number,
    number
];
export type Projected = {
    x: number;
    y: number;
    scale: number;
    z: number;
};
/** Minimal pinhole camera in design space: +z goes into the screen. */
export class Camera {
    fov: number;
    position: Vec3;
    /** Rotation about the x axis (tilt), radians. Positive tilts the camera down. */
    pitch: number;
    yaw: number;
    constructor({ fov = 55, position = [0, 0, 0] as Vec3, pitch = 0, yaw = 0 } = {}) {
        this.fov = fov;
        this.position = position;
        this.pitch = pitch;
        this.yaw = yaw;
    }
    get focal(): number {
        return DESIGN_H / 2 / Math.tan((this.fov * Math.PI) / 360);
    }
    project([x, y, z]: Vec3): Projected | null {
        let dx = x - this.position[0];
        let dy = y - this.position[1];
        let dz = z - this.position[2];
        const cy = Math.cos(this.yaw);
        const sy = Math.sin(this.yaw);
        [dx, dz] = [dx * cy - dz * sy, dx * sy + dz * cy];
        const cp = Math.cos(this.pitch);
        const sp = Math.sin(this.pitch);
        [dy, dz] = [dy * cp - dz * sp, dy * sp + dz * cp];
        if (dz <= 1)
            return null;
        const s = this.focal / dz;
        return { x: DESIGN_W / 2 + dx * s, y: DESIGN_H / 2 + dy * s, scale: s, z: dz };
    }
}
